var _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgThankyouMainIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.82 37.115a2.932 2.932 0 002.93-2.93V24.23C77.75 9.27 68.411 0 53.543 0H24.48C9.52 0 .25 9.269.25 24.242v29.062C.25 68.231 9.519 77.5 24.48 77.5h29.074c14.927 0 24.196-9.269 24.184-24.207a2.964 2.964 0 10-5.928 0c0 11.757-6.475 18.267-18.267 18.267H24.48C12.69 71.56 6.18 65.05 6.18 53.293V24.23c0-11.791 6.51-18.301 18.313-18.301h29.062c11.796 0 18.267 6.471 18.267 18.301V34.088a2.963 2.963 0 002.965 2.957v.07h.034z",
    fill: "url(#thankyouMainIcon_svg__paint0_linear_14255_19241)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.333 37.333h-1.667a1.667 1.667 0 000 3.334h1.667a1.666 1.666 0 100-3.334zm0 6.667h-1.667a1.667 1.667 0 000 3.333h1.667a1.667 1.667 0 000-3.333zm-10-10h10a1.666 1.666 0 100-3.333h-10a1.667 1.667 0 000 3.333zM54 24H30.666A1.667 1.667 0 0029 25.667v5h-5a1.667 1.667 0 00-1.667 1.666V49a5 5 0 005 5H49a6.667 6.667 0 006.666-6.667V25.667A1.667 1.667 0 0054 24zM29 49a1.666 1.666 0 11-3.334 0V34H29v15zm23.333-1.667A3.334 3.334 0 0149 50.667H32.033a5.001 5.001 0 00.3-1.667V27.333h20v20zm-15-6.666H39a1.667 1.667 0 000-3.334h-1.667a1.667 1.667 0 000 3.334zm0 6.666H39A1.667 1.667 0 0039 44h-1.667a1.667 1.667 0 000 3.333z",
    fill: "url(#thankyouMainIcon_svg__paint1_linear_14255_19241)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "thankyouMainIcon_svg__paint0_linear_14255_19241",
    x1: 43.559,
    y1: 145.549,
    x2: 106.275,
    y2: 118.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#01D6B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#218FEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "thankyouMainIcon_svg__paint1_linear_14255_19241",
    x1: 40.961,
    y1: 80.341,
    x2: 66.955,
    y2: 67.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#01D6B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#218FEE"
  })))));
}

export default SvgThankyouMainIcon;